"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _shader = _interopRequireDefault(require("./shader"));

var grayBase = '#777777';
var gray = {
  dark40: (0, _shader["default"])(-0.4, grayBase),
  //#111
  dark30: (0, _shader["default"])(-0.3, grayBase),
  //#2B2B2B
  dark20: (0, _shader["default"])(-0.2, grayBase),
  //#444
  dark10: (0, _shader["default"])(-0.1, grayBase),
  //#5E5E5E
  base: grayBase,
  light10: (0, _shader["default"])(0.1, grayBase),
  //#919191
  light20: (0, _shader["default"])(0.2, grayBase),
  //#AAA
  light30: (0, _shader["default"])(0.3, grayBase),
  //#C3C3C3
  light40: (0, _shader["default"])(0.4, grayBase),
  //#DDD
  light45: (0, _shader["default"])(0.45, grayBase) //#EAEAEA

};
var _default = gray;
exports["default"] = _default;